<template>
  <div class="modal fade" id="getAccessModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-content--access">
        <button
          type="button"
          class="modal-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <svg width="24" height="24">
            <use href="/static/images/sprite/sprite.svg#close-modal"></use>
          </svg>
        </button>
        <div class="modal-wrap">
          <div class="modal-header">
            <div>
              <img src="@/assets/images/logo/logo-icon.svg" alt="" />
            </div>
            <h2 class="modal-title title title__xl dark" v-html="title"></h2>
          </div>
          <div class="modal-body">
            <p class="text-center" v-html="text"></p>
          </div>
          <div class="modal-footer">
            <a :href="$getSubdomainLink('payment', '/sign-up')" class="btn">
              Join now
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalAccess",
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
